<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || $t('site.func.selecTime')"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <cpDatePicker
                        type="date"
                        :errorStatus="errors.has('startDate')"
                        :errorMsg="errors.first('startDate')"
                        v-model="startDate"
                        v-validate="'required'"
                        :label="$t('site.noun.startdate')"
                        name="startDate"
                        ref="startDate"
                    ></cpDatePicker>
                    <br>
                    <cpDatePicker
                        type="date"
                        :errorStatus="errors.has('endDate')"
                        :errorMsg="errors.first('endDate')"
                        v-model="endDate"
                        v-validate="'required|isAfter:'+ startDate"
                        :label="$t('site.noun.enddate')"
                        name="endDate"
                        ref="endDate"
                    ></cpDatePicker>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'
    import cpDatePicker from '@/components/cpDatePicker'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
            cpDatePicker,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){

            return {
                startDate: '',
                endDate: '',
            }
        },
        computed: {
            btns: function(){

                return [
                    {
                        text: this.$t('site.func.download'),
                        themes: 'info',
                        func: 'action',
                    },
                    {
                        text: this.$t('site.func.popupclose'),
                        func: 'close',
                    }
                ]
            },
        },
        methods: {
            action: function(){

                this.$validator.validate().then(result => {
                    let $content = this.content,
                        $_action = $content.action;

                    $_action(this.startDate, this.endDate, this.close);
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
